import PropTypes from 'prop-types';
import React from 'react';

const Header = ({ label }) => <span>{label}</span>;

Header.propTypes = {
    // eslint-disable-next-line react/require-default-props
    label: PropTypes.node,
};

export default Header;
